import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useStatsStore } from '@/store/stats'
import { api } from '@/lib/api'

export const Route = createFileRoute('/')({
  component: Dashboard,
})

function formatUptime(secs: number) {
  const h = Math.floor(secs / 3600)
  const m = Math.floor((secs % 3600) / 60)
  const s = secs % 60
  return `${h}h ${m}m ${s}s`
}

function Dashboard() {
  const { stats, latency, solPrice } = useStatsStore()
  const [grpcData, setGrpcData] = useState<any[]>([])

  useEffect(() => {
    api.getGrpc().then(setGrpcData).catch(() => {})
    const iv = setInterval(() => {
      api.getGrpc().then(setGrpcData).catch(() => {})
    }, 5000)
    return () => clearInterval(iv)
  }, [])

  const fmtDelay = (ms: number) => ms < 1000 ? `${Math.round(ms)}ms` : `${(ms / 1000).toFixed(1)}s`

  const cards = [
    { label: 'SOL Price', value: solPrice != null ? `$${solPrice.toFixed(2)}` : '-' },
    { label: 'Total TX Processed', value: stats.total_processed.toLocaleString() },
    { label: 'Duplicates', value: stats.total_duplicates.toLocaleString() },
    { label: 'Errors', value: stats.total_errors.toLocaleString() },
    { label: 'Uptime', value: formatUptime(stats.uptime_secs) },
    { label: 'Connections', value: stats.total_connections },
    { label: 'Watched Tokens', value: stats.watched_tokens },
    { label: 'Avg Delay', value: latency ? fmtDelay(latency.avg) : '-' },
    { label: 'Min Delay', value: latency ? fmtDelay(latency.min) : '-' },
    { label: 'Max Delay', value: latency ? fmtDelay(latency.max) : '-' },
  ]

  return (
    <div>
      <h1 style={{ fontSize: 20, marginBottom: 20 }}>Dashboard</h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12, marginBottom: 24 }}>
        {cards.map((c) => (
          <div key={c.label} className="card">
            <div style={{ color: 'var(--text-dim)', fontSize: 12, marginBottom: 4 }}>{c.label}</div>
            <div style={{ fontSize: 22, fontWeight: 700 }}>{c.value}</div>
          </div>
        ))}
      </div>

      <h2 style={{ fontSize: 16, marginBottom: 12 }}>GRPC Endpoints</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {grpcData.map((item: any) => (
          <div key={item.endpoint.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontWeight: 600 }}>{item.endpoint.url}</div>
              <div style={{ color: 'var(--text-dim)', fontSize: 12 }}>
                {item.status.active_connections} connections &middot; {item.status.tx_per_second.toFixed(1)} tx/s &middot; {item.status.total_tx.toLocaleString()} total
              </div>
            </div>
            <span className={`badge ${item.endpoint.enabled ? 'badge-green' : 'badge-red'}`}>
              {item.endpoint.enabled ? 'active' : 'disabled'}
            </span>
          </div>
        ))}
        {grpcData.length === 0 && <div style={{ color: 'var(--text-dim)' }}>No GRPC endpoints configured</div>}
      </div>
    </div>
  )
}
